<template>
  <div class="login px-1 bg-light pt-5">
    <div class="mx-auto px-4 kovatek-login border shadow-lg pt-2 bg-white mb-5">
      <form class="py-3 px-md-2 mx-auto" @submit="loginHandler($event)">
        <div class>
          <a href="https://beta.kovatek.com">
            <img
              class="navbar-brand logo-size my-4"
              src="../assets/kovatek/kovatek-logo.png"
              alt="Kovatek"
            />
          </a>
          <div class="alert alert-success" v-if="message">
            <strong>{{message}}</strong>
          </div>
          <p class="text-danger font-weight-bolder" v-if="error">{{ error }}</p>
          <!-- <h4 class="font-weight-bolder mb-3">Login</h4> -->
          <!-- <div class="m-auto">
                                <button class="btn add-grey shadow-sm py-3 w-100 mt-2 mb-3">
                                    <font-awesome-icon :icon="['fab', 'github']" class="mx-2 icon-size" />Login with Github</button>
          </div>-->
          <!-- <a-divider class="m-0 p-0">OR</a-divider> -->
          <div class="my-3">
            <input
              type="email"
              class="form-control input-height"
              id="email"
              placeholder="Email Address"
              v-model="email"
              required
            />
          </div>
        </div>
        <div class="m-auto">
          <button class="btn btn-kovatek mt-3 w-100 mb-4" type="submit">Reset password</button>
          <p class="text-danger font-weight-bolder" v-if="error">{{ error }}</p>
        </div>
        <!-- <a-divider /> -->
        <!-- <p>Haven't verify account? <router-link to="/token" class="font-weight-bold kova-text"><a>Request verification email</a></router-link> </p> -->
      </form>
    </div>
    <!-- </div> -->
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
export default {
  name: "login",
  components: {
    Footer
  },
  data() {
    return {
      email: "",
      message: "",
      error: null
    };
  },
  computed: {
    isLoggedIn: () => {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    loginHandler(event) {
      event.preventDefault();
      const { email } = this;
      const isValid = email === "";

      if (!isValid) {
        const data = {
          email: email
        };
        // console.log(data)

        this.$store
          .dispatch("forgetPassword", data)
          .then(resp => {
            // console.log(resp, resp.headers)
            // console.log(this.$http.defaults);
            if (resp.data) {
              this.message = "Password Reset Mail sent Succesfuly, Kindly check your inbox.";
            }
          })
          .catch(() => {
            // console.log("got error "+err)
            // console.log(err.response)
            /* this.error = err.response.data.split(":")[1]; */
            this.error = "User does not exist";
          });
      } else {
        this.error = "Invalid inputs";
      }
    }
  }
};
</script>
<style scoped>
.input-title {
  margin-left: 25px;
  font-size: 13px;
}

.logo-size {
  height: 45px;
  width: 150px;
}

.kovatek-login {
  width: 600px;
}
.add-grey {
  background-color: #ddd;
}
.add-grey:hover {
  background-color: #ccc;
}
.input-height {
  height: 50px;
  font-size: 13px;
  width: 100%;
}

.btn-kovatek {
  background-color: #20409a;
  height: 50px;
  color: #fff;
  transition: 0.25s;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.icon-size {
  font-size: 20px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .kovatek-login {
    width: 400px;
  }
  .input-height {
    font-size: 16px;
  }
}

@media (max-width: 450px) {
  .kovatek-login {
    width: 100%;
  }
}
</style>